import { Map, Record, List } from 'immutable';

const struct = {
  id:                            undefined,
  source:                        undefined,
  scoreRating:                   undefined,
  scheduledAt:                   undefined,
  record:                        new Map(),
  responses:                     new List(),
  prompts:                       new List(),
  folder:                        new Map(),
  email:                         undefined,
  msisdn:                        undefined,
  firstName:                     undefined,
  lastName:                      undefined,
  gender:                        undefined,
  education:                     undefined,
  schoolName:                    undefined,
  graduationYear:                undefined,
  lastEmployer:                  undefined,
  yearsOfExp:                    undefined,
  profileAttributes:             new List(),
  address:                       new Map(),
  createdAt:                     undefined,
  updatedAt:                     undefined,
  deletedAt:                     undefined,
  bearerToken:                   undefined,
  callToActionCompletionMessage: undefined,
};

export default class CandidateApplication extends Record(struct, 'CandidateApplication') {

}
